import React from 'react';

import ActivityLog from 'components/ActivityLog';
import RightSideBar from 'components/RightSideBar';
import VisibleIf from 'components/VisibleIf';
import {BookingNotes} from './components';

import activityLogIcon from 'assets/icons/activity-log-icon.svg';
import notesIcon from 'assets/icons/notes-icon.svg';

import {PERMISSIONS} from 'ducks/auth';

const NotesContent = ({bookingId, locationRef, bookingNotes}) => {
  return (
    <BookingNotes
      bookingNotes={bookingNotes}
      bookingId={bookingId}
      locationRef={locationRef}
    />
  );
};

const BookingDetailRightSideBar = ({bookingId, locationRef, bookingNotes}) => {
  const notesThatRequireAction = bookingNotes.filter(
    note => note.needsToBeResolved
  );

  const rightSideBarTabs = [
    {
      url: activityLogIcon,
      ref: 'activity',
      label: 'Activity'
    },
    {
      url: notesIcon,
      ref: 'notes',
      label: 'Notes',
      count: notesThatRequireAction.length
    }
  ];

  return (
    <RightSideBar tabs={rightSideBarTabs}>
      {({openedTab}) => (
        <React.Fragment>
          {openedTab === 'notes' && (
            <React.Fragment>
              <VisibleIf
                permission={PERMISSIONS.VIEW_BOOKING_NOTES}
                locationRef={locationRef}>
                <NotesContent
                  bookingId={bookingId}
                  locationRef={locationRef}
                  bookingNotes={bookingNotes}
                />
              </VisibleIf>
              <VisibleIf
                not
                permission={PERMISSIONS.VIEW_BOOKING_NOTES}
                locationRef={locationRef}>
                <div className="colab-centered">
                  You have no permission to view Booking Notes
                </div>
              </VisibleIf>
            </React.Fragment>
          )}
          {openedTab === 'activity' && (
            <React.Fragment>
              <VisibleIf
                permission={PERMISSIONS.VIEW_ACTIVITY_LOG}
                locationRef={locationRef}>
                <ActivityLog bookingId={bookingId} />
              </VisibleIf>
              <VisibleIf
                not
                permission={PERMISSIONS.VIEW_ACTIVITY_LOG}
                locationRef={locationRef}>
                <div className="colab-centered">
                  You don't have permission to view the Activity Log
                </div>
              </VisibleIf>
            </React.Fragment>
          )}
        </React.Fragment>
      )}
    </RightSideBar>
  );
};

export default BookingDetailRightSideBar;
